import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useCommonJson = (loName) => {

    const [loData, setLoData] = useState(null);
    const navigate = useNavigate();

    // const path = process.env.REACT_APP_CDN + "swmc/jsons/loanOfficer/loanOfficerJson/";
    const path1 = "https://" + loName + ".sunwestmortgage.com/includes/" + loName + ".json"
    const fetchData = async () => {
        try {
            const data = await fetch(path1);
            const jsonData = await data.json();
            if (!jsonData || jsonData.length === 0) {
                // If jsonData is empty, navigate to home page
                navigate('/refinance/', { replace: true });
            } else {
                setLoData(jsonData[0]);
            }
        } catch (error) {
            console.error("Error fetching LO data:", error);
            navigate('/refinance/', { replace: true });
        }
    }

    useEffect(() => {
        if (loName) {
            fetchData();
        }
    }, [loName, navigate]);  // Trigger fetch when loName changes

    return loData;
}

export default useCommonJson;
